import Molde from "./MoldeTrek";
import CardLugar from "../common/card/CardLugar";
import CardRecomienda from "../common/card/CardRecomienda";
import CardCaracteristica from "../common/card/CardCaracteristica";
import React from 'react';


export default function Caminoinca1x2() {

  const tourItemsIncluye = [
  "Información previa al tour: Te reunirás con tu guía del Camino Inca en nuestras oficinas (u otro lugar acordado) alrededor de las 18:00 horas para una sesión informativa sobre su viaje.",
  "Transporte turístico “Cusco – Ollantaytambo” (ida y vuelta).",
  "Tren turístico “Expediciones” al Km 104, Chachabamba.",
  "Tren turístico “Expediciones” de Aguas Calientes a Ollantaytambo.",
  "03 Buses Consettur a ciudadela de Machu Picchu (bajada, subida y bajada).",
  "Guía profesional altamente calificado de habla inglesa y española en el Camino Inca.",
  "Guía profesional altamente calificado de habla inglesa y española en Machu Picchu.",
  "Ticket de ingreso al Camino Inca corto.",
  "Ticket de ingreso a la ciudadela Inca de Machu Picchu (Casa del Guardian, Circuito 1 y Circuito 3).",
  "Hotel en Aguas Calientes incluido, brindándote todos los servicios que necesitarás: agua caliente, baño privado, Wi-Fi y desayuno.",
  "1 desayuno, 1 almuerzo para llevar, 1 cena (Opciones: vegetariana, vegana, sin gluten, etc.).",
  "Botiquín de primeros auxilios y tanque de oxígeno. (Nuestros guías están altamente capacitados en primeros auxilios y rescate en montaña, con un plan integral de atención, evacuaciones terrestres y evacuaciones aéreas)",
  "Servicio de Atención al Cliente las 24 horas: Ofrecemos un servicio telefónico disponible las 24 horas del día.",
  "Almacen de equipaje gratuito (Free): Brindamos resguardo de equipaje en nuestras oficinas en Cusco. Podrás dejar tu equipaje antes de iniciar tu recorrido (exclusivo para nuestros pasajeros)."
];
const tourItemsNoIncluye = [
"Los bastones de trekking no están incluidos, pero se recomiendan para la caminata. Puedes alquilar con nosotros o llevar unas propias.",
"Ingreso a sitios adicionales (Huayna Picchu / Montaña Machupicchu*).",
"El almuerzo en el 2do día y desayuno en el 1er día.",
"Additional costs or delays beyond our control, such as natural disasters, adverse weather conditions, itinerary modifications due to passenger health issues (suffering from an illness or health problems), pandemic, changes in government policies, political instability, strikes, etc."

];
const extras =[
  "Bastones de trekking. ($15.00 USD)",
  "Almuerzo Económico en Aguas Calientes. ($15.00 USD)",
  "Almuerzo en Sanctuary Lodge. ($45.00 USD)",
  "Ingreso a Wayna Picchu, sujeto a disponibilidad y horarios: 7:00 am / 8:00 am / 9:00 am / 10:00 am ($60.00 USD)",
  "Entrada montaña Machupicchu*, sujeto a disponibilidad y horarios: 8:00 am / 9:00 am ($60.00 USD)",
  "Tour guiado por Huayna Picchu o montaña Machupicchu *. ($75.00 USD por grupo)",
  "Actualice su servicio de tren Vistadome en el regreso. ($50.00 USD)",
  "Actualice su servicio de tren Vistadome Observatory en el regreso. ($75.00 USD)",
  "Camping bajo solicitud. ($50.00 USD)",
  "Podemos ayudarle en la reserva de hoteles (estándar y de lujo) en todo el Perú."
];
const llevar =[
  "Pasaporte original (y Carnet de estudiante vigente si aplicó a esta opción).",
  "Botas / zapatos para caminar.",
  "Casaca impermeable / poncho de lluvia.",
  "Chaqueta, gorro y guantes abrigados.",
  "Polos manga corta o larga.",
  "Pantalones cómodos.",
  "Sombrero para el sol.",
  "Gafas de sol.",
  "Crema de protección solar (se recomienda factor 35)",
  "Botellas de plástico o metal reutilizable, o camelbak.",
  "Agua, en el camino es posible comprar botellas de agua de las familias locales.",
  "Repelente de insectos.",
  "Medicación personal.",
  "Cámara y filmadora.",
];
const arti_adi=[
  "Pantalones cortos.",
  "Bastón (con punta de goma).",
  "Yesos y vendajes.",
  "Sandalias.",
  "Traje de baño.",
  "Dinero extra para gastos personales, propinas (se recomiendan 200 nuevos soles peruanos para el dinero extra)",
  ];
const importante=[
  "El itinerario puede cambiar debido a disposiciones del gobierno peruano, condiciones climáticas y el estado de salud de los excursionistas.",
  "El horario del tren puede variar según la disponibilidad de la empresa ferroviaria.",
  "Ofrecemos el tren Expedition hacia Ollantaytambo: si alguien reserva su billete de tren a última hora, no se garantiza que pueda estar en el mismo tren que el resto del grupo.",
  "Si deseas cambiar el horario o los boletos de tu tren, deberás pagar un cargo adicional por el transporte desde Ollantaytambo a Cusco y por la diferencia en el precio del tren.",
];
  return (
    <>
      <Molde
        image={"/images/portada_camino_inca.png"}
        title={"CAMINO INCA 2D/1N"}
        subtitle={"2 DIAS / 1 NOCHE"}
        description={
          "Experimente el increible Camino Inca Corto en 2 días, una combinación de aventura y lujo diseñada para aquellos con tiempo limitado. Con una duración de 12 km, esta caminata pasa a través de exuberantes paisajes del valle de Urubamba y fauna diversa, sumergiéndote en senderos antiguos. Los lugares más destacados que incluye son Wiñayhuayna, Inti Punku Puerta del Sol, La casa del Guardián con impresionantes vistas de Machu Picchu y el Santuario de Machu Picchu y sus cautivadores momentos del atardecer y el amanecer. Somos una agencia de viajes y operadores locales en Cusco autorizada, ofrecemos salidas diarias, aunque se recomienda reservar con anticipación debido al límite de visitantes del Camino Inca."
        }
        linkForm={"/reservar/citytour-dia"}
        /*tipoprecio={"Precio por persona"}
        monto={"US$ 800.00"}
        moneda={"DOLARES"}*/
        mapa={
          <>
            
            <img className="rounded-lg border-primary-800 border-2" src={`${process.env.PUBLIC_URL}/images/mapa_camino_inca.png`} alt="" />
          </>
        }
        itinerario={<>
            <div className="mb-4">
                                <h1 className="font-bold text-primary-800 pb-4">ITINERARIO</h1>
                                <div className="bg-primary-800 p-2 rounded-lg w-full">
                                  <h2 className="text-primary-50 font-bold">Día 1 | INCA TRAIL</h2>
                                </div>
                                <h4 className="text-primary-800 py-4 font-semibold">Caminata Chachabamba, Km 104 – Puerta del Sol – Machu Picchu</h4>
                                <img className="w-full rounded-lg " src={`${process.env.PUBLIC_URL}/images/camino_inca_2_1.png`} alt="" />
                                <div className="mt-2 text-primary-800">
                                  <p className="mb-2">Te recogeremos muy temprano por la mañana (04:50 a.m.) para salir de la ciudad del Cusco rumbo a la estación de tren para abordar el servicio que nos llevará al Km104 de la línea férrea de la ruta Cusco – Machu Picchu, lugar que será el punto de inicio de la caminata.</p>
                                  <p className="mb-2">A la parada del tren, en el Km 104, haremos el ingreso a la Red de Camino Inca, cruzando Puente para ingresar a Chachabamba, un pequeño grupo arqueológico que pertenece al Santuario Histórico de Machu Picchu.</p>
                                  <p className="mb-2">Chachabamba fue descubierto el año de 1940 y está localizada en la rivera del río Urubamba. El estilo de su construcción en la piedra labrada sugiere que fue un importante lugar religioso, y que pudo tener como segunda función ser la puerta de ingreso a Machu Picchu.</p>
                                  <p className="mb-2">Luego de visitar el lugar, comenzaremos el ascenso, para luego de 2 horas de camino ingresar a un hermoso valle donde comenzará a mostrarse el Bosque Nublado, aquí nos tomaremos una pausa para disfrutar del lunch box.</p>
                                  <p className="mb-2">Después del almuerzo, continuaremos el recorrido hasta alcanzar una hermosa caída de agua, para luego llegar a Wiñaywayna, uno de los lugares arqueológicos con mayor importancia después de Machu Picchu.</p>
                                  <p className="mb-2">Por la tarde, finalmente llegaremos a 'La Puerta del Sol' (Intipunku) desde donde comenzaremos nuestro descenso. Este lugar es el punto de vista clásico de la ciudadela de Machu Picchu. Luego retornaremos al pueblo de Aguas Calientes.</p>
                                </div>
                              </div>
                              <div>
                                <div className="bg-primary-800 p-2 rounded-lg w-full">
                                  <h2 className="text-primary-50 font-bold">Día 1 | INCA TRAIL</h2>
                                </div>
                                <h4 className="text-primary-800 py-4 font-semibold">Aguas Calientes – Machu Picchu Visita Guiada – Cusco</h4>
                                <img className="w-full rounded-lg " src={`${process.env.PUBLIC_URL}/images/camino_inca_2_1_2.png`} alt="" />
                                <div className="mt-2 text-primary-800">
                                  <p className="mb-2"> Después del desayuno, abordarás el bus Consettur y enseguida comenzarás el ascenso a la Ciudadela.</p>
                                  <p className="mb-2"> Una vez arriba, harás el tour por Machu Picchu, aprendiendo la historia y misterios de este Santuario, que es una de las Siete Nuevas Maravillas del Mundo.</p>
                                  <p className="mb-2"> Con la frescura del clima matutino y la energía que se siente desde los impresionantes paisajes por doquier, podrás tomar increíbles fotografías.</p>
                                  <p className="mb-2"> Finalizando tu visita dentro de la Ciudadela, podrás descender y tendrás tiempo para almorzar en Machu Picchu Pueblo. (No incluido).</p>
                                  <p className="mb-2"> Finalmente, abordarás The 360° Machu Picchu Train para tu viaje de regreso.</p>
                                  <p className="mb-2"> A tu llegada, serás trasladado a tu hotel en el centro histórico de Cusco.</p>
                                </div>
                              </div></>
        }
        galeria={
            <>
              <img className="rounded-lg" src={`${process.env.PUBLIC_URL}/images/colores_1.png`} alt="" />
              <img className="rounded-lg" src={`${process.env.PUBLIC_URL}/images/colores_2.png`} alt="" />
              <img className="rounded-lg" src={`${process.env.PUBLIC_URL}/images/colores_3.png`} alt="" />
              <img className="rounded-lg" src={`${process.env.PUBLIC_URL}/images/colores_4.png`} alt="" />
              <img className="rounded-lg" src={`${process.env.PUBLIC_URL}/images/colores_5.png`} alt="" />
              <img className="rounded-lg" src={`${process.env.PUBLIC_URL}/images/colores_6.png`} alt="" />
            </>
          }
        incluye={
          <ul className="space-y-3">
            {tourItemsIncluye.map((item, index) => (
              <li key={index} className="flex items-start gap-2 text-sm text-gray-700">
                <span className="text-green-600 font-bold mt-1">✔</span>
                <span className="text-primary-800">{item}</span>
              </li>
            ))}
          </ul>
        }
        
        noIncluye={
          <ul className="space-y-3">
            {tourItemsNoIncluye.map((item, index) => (
              <li key={index} className="flex items-start gap-2 text-sm text-gray-700">
                <span className="text-red-600 font-bold mt-1">✖</span>
                <span className="text-primary-800">{item}</span>
              </li>
            ))}
          </ul>
        }
        extras={
          <ul className="space-y-3">
            {extras.map((item, index) => (
              <li key={index} className="flex items-start gap-2 text-sm text-gray-700">
                <span className="text-blue-600 font-bold mt-1">➕</span>
                <span className="text-primary-800">{item}</span>
              </li>
            ))}
          </ul>
        }
        llevarTrek={
          <ul className="space-y-3">
            {llevar.map((item, index) => (
              <li key={index} className="flex items-start gap-2 text-sm text-gray-700">
                <span className="text-blue-600 font-bold mt-1">➕</span>
                <span className="text-primary-800">{item}</span>
              </li>
            ))}
          </ul>
        }
        articulo_add={
          <ul className="space-y-3">
            {arti_adi.map((item, index) => (
              <li key={index} className="flex items-start gap-2 text-sm text-gray-700">
                <span className="text-blue-600 font-bold mt-1">➕</span>
                <span className="text-primary-800">{item}</span>
              </li>
            ))}
          </ul>
        }
        importante={
          <ul className="space-y-3">
          {importante.map((item, index) => (
            <li key={index} className="flex items-start gap-2 text-sm text-gray-700">
              <span className="text-yellow-600 font-bold mt-1">❗</span>
              <span>{item}</span>
            </li>
          ))}
        </ul>
        }

        caracteristica={
          <>
            <CardCaracteristica
              icon={`${process.env.PUBLIC_URL}/icons/level.svg`}
              title={"Dificultad"}
              desc={"Dificil"}
            />
            <CardCaracteristica
              icon={`${process.env.PUBLIC_URL}/icons/compartido.svg`}
              title={"Tipo Servicio"}
              desc={"4/10 personas"}
            />
            <CardCaracteristica
              icon={`${process.env.PUBLIC_URL}/icons/duracion.svg`}
              title={"Duración"}
              desc={"2 Días/1 Noche"}
            />
            <CardCaracteristica
              icon={`${process.env.PUBLIC_URL}/icons/cultural.svg`}
              title={"Tipo de Tour"}
              desc={"Trekking"}
            />
          </>
        }
        
        TourRecomienda={
                  <>
                    <CardRecomienda
                      img={"/images/montania_colores.png"}
                      title={"MONTAÑA 7 COLORES"}
                      puntuacion={"4.5"}
                      link={'/tour-tradicional/montania-colores'}
                    />
                    <CardRecomienda
                      img={"/images/valle-vip-5.png"}
                      title={"VALLE VIP"}
                      puntuacion={"5"}
                      link={'/tour-tradicional/valle-vip'}
                    />
                    <CardRecomienda
                      img={"/images/cris-1.png"}
                      title={"CITY TOUR"}
                      puntuacion={"5"}
                      link={'/tour-tradicional/citytour'}
                    />
                    <CardRecomienda
                      img={"/images/maras-moray-4.png"}
                      title={"MARAS-MORAY"}
                      puntuacion={"4.5"}
                      link={'/tour-tradicional/maras-moray'}
                    />
                  </>
                }
      />
    </>
  );
}
